import { render, staticRenderFns } from "./TransactionTip.vue?vue&type=template&id=047a9984&"
import script from "./TransactionTip.vue?vue&type=script&lang=ts&"
export * from "./TransactionTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports